import { Module } from '../Module';
import { SiteRoleOptionsResource } from '../../userManagement/services/resources/SiteRoleOptions';

export interface ISiteRoleFilter {
  (siteRole: string): string;
}

Module.instance().filter('siteRole', [
  '$translate',
  ($translate: ng.translate.ITranslateService): ISiteRoleFilter => {
    return (siteRole: string) => {
      return siteRole ? $translate.instant(SiteRoleOptionsResource.instance.getSiteRoleLockey(siteRole)) : '';
    };
  }
]);
